import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SettingService } from '../services/settingService/setting.service';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { ToastrService } from 'ngx-toastr';
import { MatSort } from '@angular/material/sort';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { FormGroup, FormBuilder } from '@angular/forms';

@Component({
  selector: 'app-manage-QuestionTemplatecategory',
  templateUrl: './manage-QuestionTemplatecategory.component.html',
  styleUrls: ['./manage-QuestionTemplatecategory.component.scss']
})
export class ManageQuestionTemplateCategoryComponent implements OnInit { 
  
  formDialog: FormGroup;
  pageModelData = {
    pageIndex: 0,
    pageSize: 10,
    searchValue: '',
  };  
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  currentUser: any;
  organizationId: string;
  databaseId: string;
  responseHolder: any;  
  value = '';
  filterText: any;   
  totalCount: any;
  paginatorTotalLength: any;
  pageIndex: any;
  pageSize: any;
  currentData: PageEvent;  
  OfficeIDList: any=[];
  myOfficeID: any;
  spinner:boolean=false;
  selectedCategoryID:number=0;
  ShowNoRecordFound:boolean=false;
  categoryList: any[] = [];
  masterTemplateList: any[] = [];
  categoryName:string="";
  nlpTemplateCategoryID:number=0;

  constructor(private formBuilder: FormBuilder, private loaderService: LoaderService, private toastr: ToastrService,
     private statusConst: StatusConstant, private reusableClass: ReusableClasses, private dialog: MatDialog,
     private settingsService: SettingService, private encryptionAlgo: EncryptionService,) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    this.currentUser = jwt_decode(token);
    var offices=JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
    this.OfficeIDList.push(oe.officeID);
    if(oe.isMyoffice==true)
      this.myOfficeID=oe.officeID;
    });
  }

  ngOnInit(): void {
    let group = {};
    this.formDialog = new FormGroup(group);
    this.formDialog.addControl('categoryName',this.formBuilder.control(''));    
    this.getQuestionTempCategoryList();
  }

   // For Get All Question Temp Category List
   getQuestionTempCategoryList(){
    var ReqModel = {
      type: this.categoryType, // 0 For My Templates
      isCategoriesOnly: true,
      isAll: true,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList,
      databaseID: Number(this.databaseId)      
    }
     this.loaderService.show();
     this.settingsService.getNLPTemplateCategories(ReqModel).subscribe(response => {
     if (response != undefined) {
        this.responseHolder = response;
        this.loaderService.hide();
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
           if(this.responseHolder.data!=null){
              this.categoryList=this.responseHolder.data;     
              if(this.categoryList.length>0){              
                this.ShowNoRecordFound=false;
             }else{
                this.ShowNoRecordFound=true;
              } 
             }
         }else{
          this.categoryList=[];
          this.ShowNoRecordFound=true;
          this.loaderService.hide();
         }
       }else{
        this.categoryList=[];
        this.ShowNoRecordFound=true;
        this.loaderService.hide();
       }
     });
   }   
   

   //For  Open Pop (Update Category)
   openDialogUpdateType(templateRef: TemplateRef<any>, type: any) {
    this.formDialog.markAsPristine();
    this.formDialog.controls.categoryName.setValue(type.nlpTemplateCategoryName);
    this.nlpTemplateCategoryID=type.nlpTemplateCategoryID;
    this.dialog.open(templateRef, {
    });
   }
   

   // For Update Question Category name
   UpdateCategoryNameDetails(data) {
    this.spinner=true;
    this.formDialog.markAsPristine();   
    var ReqModel = {
        nlpTemplateCategoryID: this.nlpTemplateCategoryID,
        nlpTemplateCategoryName: data.categoryName.trim(),       
        userId: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeIDList:this.OfficeIDList,
        officeID:this.myOfficeID,
        databaseID: Number(this.databaseId),
    }
    this.settingsService.renameNLPTemplateCategory(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.spinner=false;      
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess){         
          this.toastr.success('Question Category name updated successfully.', '', {
            timeOut: 3000,
          });         
          this.getQuestionTempCategoryList();
          this.dialog.closeAll();
        }else{
          this.toastr.warning('Question Category already exist.', '', {
            timeOut: 2000,
          });
          this.spinner=false;         
        }
      }else{
        this.spinner=false;       
      }
    });
   }

   // For Update Question  Category Status
   UpdateStatusToggle(type: any,event: any) {
    this.loaderService.show();
    var ReqModel = {
      activate: event.checked,     
      nlpTemplateCategoryID:type.nlpTemplateCategoryID,
      userId: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeIDList:this.OfficeIDList,
      officeID:this.myOfficeID,
      databaseID: Number(this.databaseId),
    }
    this.settingsService.activateNLPCategoryTemplate(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {          
          this.toastr.success('Question Category status updated successfully.', '', {
            timeOut: 3000,
          });
          this.getQuestionTempCategoryList(); 
          this.loaderService.hide();
        }else{
          this.loaderService.hide();
        }
      }else{
        this.loaderService.hide();
      }
    });
   }

   // For Delete OCR Category
   DeleteCategory(type: any) {  
    var message = `Are you sure you want to delete?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message,confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData
    });
    dialogRef.beforeClosed().subscribe(async dialogResult => {
      if (dialogResult) {
        this.loaderService.show();
        var ReqModel = {
          nlpTemplateCategoryIDs: [type.nlpTemplateCategoryID],          
          userId: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeIDList:this.OfficeIDList,
          officeID:this.myOfficeID,
          databaseID: Number(this.databaseId),
        }     
        this.settingsService.removeNLPTemplateCategories(ReqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            this.loaderService.hide();
            if (this.responseHolder.status == this.statusConst.statusSuccess) {             
              this.toastr.success('Question Category deleted successfully.', '', {
                timeOut: 3000,
              });
              this.getQuestionTempCategoryList();
              this.loaderService.hide();
            }
          }
          else{
            this.loaderService.hide();
          }
        });
      }
    });
   }
   

   close() {
    this.dialog.closeAll();
   }

   categoryType:number=0;

   OnCategoryChanged($event) {
    if($event.value == "My Template"){
      this.categoryType=0;
    }
    if($event.value == "Organization"){
      this.categoryType=2; 
    }   
    this.getQuestionTempCategoryList();
  }    
  
  
}
